import { getRightSaluation } from "./function";

const getPaymentLogAction = (eventName = "") => {
  const name = String(eventName).toLowerCase();
  if (name.includes("delete")) return "Deleted";
  if (name.includes("update")) return "Updated";
  if (name.includes("create") || name.includes("newly created")) {
    return "Added";
  }
  return eventName || "-";
};

const formatLogMoney = (value) => {
  if (value == null || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num.toFixed(2) : String(value);
};

const getPaymentLogChanges = (param = {}, action = "", previous = null) => {
  const parts = [];
  const name = param?.name || previous?.name || "";
  if (name) parts.push(name);

  const currQty = param?.quantity;
  const prevQty = previous?.quantity;
  const currPrice = formatLogMoney(param?.price);
  const prevPrice = formatLogMoney(previous?.price);

  if (action === "Updated" && previous) {
    if (
      currQty != null &&
      currQty !== "" &&
      prevQty != null &&
      prevQty !== "" &&
      String(prevQty) !== String(currQty)
    ) {
      parts.push(`Qty ${prevQty} → ${currQty}`);
    }
    if (currPrice != null && prevPrice != null && prevPrice !== currPrice) {
      parts.push(`Price ${prevPrice} → ${currPrice}`);
    }
    if (parts.length === (name ? 1 : 0)) {
      if (currQty != null && currQty !== "") parts.push(`Qty ${currQty}`);
      if (currPrice != null) parts.push(`Price ${currPrice}`);
    }
  } else {
    if (currQty != null && currQty !== "") parts.push(`Qty ${currQty}`);
    if (currPrice != null) parts.push(`Price ${currPrice}`);
  }

  return parts.length ? parts.join(", ") : "-";
};

export const flattenPaymentErrorLogs = (
  data = [],
  clinicVets = [],
  clinic = {},
) => {
  const rows = [];
  const resolvePerformerName = (performerId) => {
    if (performerId == null || performerId === "") return "-";
    const idStr = String(performerId);

    const fromVet = (clinicVets ?? []).find(
      (v) =>
        String(v?.doctorId) === idStr ||
        String(v?.userId) === idStr ||
        String(v?.id) === idStr,
    );
    if (fromVet) {
      const salutation = getRightSaluation(
        clinicVets,
        fromVet?.doctorId ?? fromVet?.userId ?? fromVet?.id,
      );
      return `${salutation}${fromVet?.name || ""}`.trim() || "-";
    }

    if (
      String(clinic?.userId) === idStr ||
      String(clinic?.id) === idStr ||
      String(clinic?.createdBy) === idStr ||
      String(clinic?.ownerId) === idStr
    ) {
      return (
        clinic?.userName ||
        clinic?.ownerName ||
        clinic?.name ||
        clinic?.clinicName ||
        `User ${idStr}`
      );
    }

    return `User ${idStr}`;
  };

  const allParams = [];
  (Array.isArray(data) ? data : []).forEach((event) => {
    const params = Array.isArray(event?.params) ? event.params : [];
    params.forEach((param) => {
      if (param?.paymentDetailId == null || param?.paymentDetailId === "") {
        return;
      }
      allParams.push({
        ...param,
        eventId: event?.eventId,
        eventCreateDate: event?.createDate,
      });
    });
  });

  allParams.sort((a, b) => {
    const aTime = a?.createdDate ? new Date(a.createdDate).getTime() : 0;
    const bTime = b?.createdDate ? new Date(b.createdDate).getTime() : 0;
    return aTime - bTime;
  });

  const lastByDetailId = {};

  allParams.forEach((param, index) => {
    const detailId = String(param?.paymentDetailId);
    const previous = lastByDetailId[detailId] || null;
    const action = getPaymentLogAction(param?.eventName);
    const performerId = param?.loginUser ?? param?.loginUserId ?? null;

    rows.push({
      key: `${param?.eventId || "evt"}_${detailId}_${index}_${param?.createdDate || ""}`,
      createdDate: param?.createdDate || param?.eventCreateDate || null,
      action,
      changes: getPaymentLogChanges(param, action, previous),
      performedBy: resolvePerformerName(performerId),
      paymentDetailId: param?.paymentDetailId,
      eventName: param?.eventName || "",
    });

    lastByDetailId[detailId] = param;
  });

  return rows.sort((a, b) => {
    const aTime = a?.createdDate ? new Date(a.createdDate).getTime() : 0;
    const bTime = b?.createdDate ? new Date(b.createdDate).getTime() : 0;
    return bTime - aTime;
  });
};
